var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoliciesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.99492C3 2.43472 4.2648 1.16992 5.825 1.16992L13.8249 1.16992L12.9999 1.16996V7.99492C12.9999 8.45056 13.3693 8.81992 13.8249 8.81992H20.6499V7.99492V7.98504C20.65 7.98833 20.65 7.99163 20.65 7.99492V19.9949C20.65 21.5551 19.3852 22.8199 17.825 22.8199H5.825C4.2648 22.8199 3 21.5551 3 19.9949V3.99492ZM20.1667 7.16993L14.6499 1.65314V7.16992L20.1667 7.16993ZM6.99994 12.9949C6.99994 12.5393 7.3693 12.1699 7.82494 12.1699H15.8249C16.2806 12.1699 16.6499 12.5393 16.6499 12.9949C16.6499 13.4505 16.2806 13.8199 15.8249 13.8199H7.82494C7.3693 13.8199 6.99994 13.4505 6.99994 12.9949ZM7.82494 16.1699C7.3693 16.1699 6.99994 16.5393 6.99994 16.9949C6.99994 17.4506 7.3693 17.8199 7.82494 17.8199H15.8249C16.2806 17.8199 16.6499 17.4506 16.6499 16.9949C16.6499 16.5393 16.2806 16.1699 15.8249 16.1699H7.82494ZM6.99994 8.99495C6.99994 8.53932 7.3693 8.16995 7.82494 8.16995H9.82494C10.2806 8.16995 10.6499 8.53932 10.6499 8.99495C10.6499 9.45059 10.2806 9.81995 9.82494 9.81995H7.82494C7.3693 9.81995 6.99994 9.45059 6.99994 8.99495Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliciesActive);
export default __webpack_public_path__ + "static/media/policies-active.e4d9a566e54bc0effb9b3d3b48d8edc1.svg";
export { ForwardRef as ReactComponent };